import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit, OnChanges {
  
  // Propiedades de configuración
  @Input() show: boolean = false;
  @Input() text: string = '';
  @Input() type: 'fullscreen' | 'absolute' | 'inline' = 'absolute';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() color: string = '#124E91';
  @Input() trackColor?: string;
  @Input() blurBackground: boolean = true;
  @Input() showText: boolean = true;
  @Input() animationStyle: 'default' | 'scale' = 'default';
  
  // Clases dinámicas
  overlayClass: string = '';
  contentClass: string = '';
  
  // Tamaños del spinner
  spinnerSize: number = 50;
  borderWidth: number = 5;
  
  ngOnInit(): void {
    this.setStyles();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['size'] || changes['type'] || changes['animationStyle']) {
      this.setStyles();
    }
  }
  
  private setStyles(): void {
    // Configurar tamaño
    switch (this.size) {
      case 'small':
        this.spinnerSize = 30;
        this.borderWidth = 3;
        break;
      case 'medium':
        this.spinnerSize = 50;
        this.borderWidth = 5;
        break;
      case 'large':
        this.spinnerSize = 70;
        this.borderWidth = 6;
        break;
    }
    
    // Configurar clases
    this.overlayClass = `custom-modal-overlay spinner-${this.type}`;
    this.contentClass = `custom-modal-content ${this.animationStyle === 'scale' ? 'spinner-animation-scale' : ''}`;
  }
  
  // Método para mostrar/ocultar programáticamente
  public toggle(show?: boolean): void {
    if (show !== undefined) {
      this.show = show;
    } else {
      this.show = !this.show;
    }
  }
}